import React from "react";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";
import { CANDIDATE_JOURNEY_STEPS } from "../../data/candidateJourneyData";

export default function CandidateJourneyPage() {
  return (
    <>
      <Hero title="Kandidatenreise" subheading="Ihr Weg vom ersten Kontakt bis zur Stelle." />
      <section id="section-kandidatenreise" className="bg-white py-16 md:py-24">
        <div className="container-app mx-auto max-w-3xl px-4">
          <p id="section-kandidatenreise-intro" className="mx-auto max-w-xl text-center text-base text-gray-600 md:text-lg">
            So funktioniert unser Prozess – von der ersten Kontaktaufnahme bis zum Einstieg. Transparent, diskret und auf Augenhöhe.
          </p>

        <div className="mt-14 space-y-0">
          {CANDIDATE_JOURNEY_STEPS.map((item, index) => (
            <div
              key={item.step}
              id={`section-kandidatenreise-${item.step}`}
              className="relative flex gap-6 md:gap-8"
            >
              {/* Vertical line (except last) */}
              {index < CANDIDATE_JOURNEY_STEPS.length - 1 && (
                <div
                  className="absolute left-[19px] top-14 bottom-0 w-px bg-gray-200 md:left-[23px]"
                  aria-hidden
                />
              )}

              {/* Step number circle */}
              <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-gray-900 bg-white text-base font-bold text-gray-900 shadow-sm md:h-14 md:w-14 md:text-lg">
                {item.step}
              </div>

              {/* Content card */}
              <div className="min-w-0 flex-1 pb-14">
                <div className="rounded-2xl border border-gray-200/80 bg-white p-6 shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-shadow hover:shadow-[0_4px_20px_rgba(0,0,0,0.06)] md:p-8">
                  <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
                    {item.title}
                  </h2>
                  <p className="mt-1 text-sm font-medium text-gray-500 md:text-base">
                    {item.subtitle}
                  </p>
                  <p className="mt-4 text-[15px] leading-relaxed text-gray-700 md:text-base">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <HighlightedContactSection
          heading="Fragen zum Ablauf oder ersten Schritt?"
          description="Sie haben Fragen zur Kandidatenreise oder möchten den ersten Schritt gehen? Wir begleiten Sie gerne."
          buttonText="Kontakt aufnehmen"
          sectionId="section-kandidatenreise-cta"
        />
      </div>
      </section>
    </>
  );
}
